import * as v from "valibot";
import { ImageKeywords } from "../../models/image";
import { pageRequest, pageResponse } from "../paging.dto";

export const adminImageStockDto = v.object({
  id: v.string(),
  alt: v.string(),
  src: v.string(),
  keyword: v.string(),
  user: v.string(),
  userProfile: v.string(),
  authorAlias: v.optional(v.string()),
  articleId: v.optional(v.string()),
  used: v.picklist(["yes", "no"]),
  createdAt: v.number(),
  updatedAt: v.number(),
});
export type AdminImageStock = v.InferOutput<typeof adminImageStockDto>;

export const listAdminImagesRequest = {
  keyword: v.picklist(ImageKeywords),
  /** Defaults to the unused stock. */
  used: v.optional(v.picklist(["yes", "no"])),
  ...pageRequest,
};

export const listAdminImagesResponse = {
  images: v.array(adminImageStockDto),
  ...pageResponse,
};

export const updateAdminImageRequest = {
  id: v.pipe(v.string(), v.minLength(1), v.maxLength(64)),
  used: v.picklist(["yes", "no"]),
};

export const updateAdminImageResponse = { image: adminImageStockDto };
